import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75d1c280"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-overlay tw-mt-4 tw-pt-4 tw-box-border tw-border-t-solid-custom" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-1 tw-items-start tw-pb-4" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-1 tw-items-start" }
const _hoisted_6 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-1 tw-items-start tw-pb-4" }
const _hoisted_7 = { class: "tw-flex tw-flex-col tw-gap-1 tw-items-start" }
const _hoisted_8 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-1 tw-items-start tw-pb-4" }
const _hoisted_9 = { class: "tw-flex tw-flex-col tw-gap-1 tw-items-start" }
const _hoisted_10 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-1 tw-items-start tw-pb-4" }
const _hoisted_11 = { class: "tw-flex tw-flex-col tw-gap-1 tw-items-start" }
const _hoisted_12 = { class: "modal-footer" }

import moment from "moment";
import { ref, computed, onMounted, watch } from "vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import { getCurrentInstance } from "@vue/runtime-core";
import { displayToastMessage } from "@/core/utils/common";
import { USER_STORE } from "@/store/modules/user";
import { WORKSTATION } from "@/store/modules/workstation";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import PdfIcon from "@/core/components/icons/PdfIcon.vue";
import ImageIcon from "@/core/components/icons/ImageIcon.vue";
import Text from "@/core/components/ui/general/Text.vue";
import InputField from "@/core/components/common/InputField.vue";
import { DATE_FORMAT } from "@/core/constants";
import { end } from "@popperjs/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddOrEditExperienceModal',
  props: ["experienceModalType", "selectedExperienceData"],
  emits: ["on-close", "on-submit", "on-success"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;
const props = __props;

const internalInstance = getCurrentInstance();
const formRef = ref<any>(null);
const isUploadImg = ref<boolean>(false);

const validation = ref({
  companyName: [(v: string) => !!v || "Enter Company Name"],
  title: [(v: string) => !!v || "Enter Title"],
  startDate: [(v: string) => !!v || "Enter Start Date"],
  //   attachments: [
  //     (v: any[]) => v.length > 0 || "At least one attachment is required",
  //   ],
});

const companyName = ref("");
const title = ref("");
const startDate = ref("");
const endDate = ref(null) as any;
const isPresent = ref(false);
const selectedAttachments = ref<any[]>([]);

const isFileUploading = ref(false);
const attachmentError = ref("");
const uploadProgress = ref(0);

const user = computed(() => store.getters[`${USER_STORE}/user`]);
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const onFileChangeAttachments = async (event: any) => {
  try {
    isFileUploading.value = true;
    attachmentError.value = "";
    uploadProgress.value = 0;

    const fileInput = event.target;
    if (fileInput.files && fileInput.files.length > 0) {
      const files = Array.from(fileInput.files);
      let progressInterval: any;

      // Add new files if they don't already exist
      files.forEach((file: any) => {
        if (!selectedAttachments.value.some((doc) => doc.name === file.name)) {
          selectedAttachments.value.push(file);
        }
      });

      // Ensure there's at least one file to upload before starting progress
      if (selectedAttachments.value.length) {
        console.log("Uploading started...");

        progressInterval = setInterval(() => {
          if (uploadProgress.value < 100) {
            uploadProgress.value += 10;
          } else {
            clearInterval(progressInterval);
          }
        }, 200);

        // Simulate async upload time
        await new Promise((resolve) => setTimeout(resolve, 2200));

        clearInterval(progressInterval);
        uploadProgress.value = 100;
      }

      event.target.value = "";
      console.log(selectedAttachments.value, "selectedAttachments.value");
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    attachmentError.value = "Error uploading file.";
  } finally {
    setTimeout(() => {
      isFileUploading.value = false;
    }, 500); // Delay hiding the loader to ensure UI updates properly
  }
};

const setEndDate = () => {
  console.log("run setEndDate");
  if (isPresent.value) {
    endDate.value = null;
  }
};

const formatIssueDate = (isoDate: any) => {
  if (isoDate === "" || isoDate === null) {
    return "";
  }
  return new Date(isoDate).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const getEndDate = () => {
  if (endDate.value !== null) {
    return moment(endDate.value, "YYYY-MM-DD").format("YYYY-MM-DD");
  }
  return endDate.value;
};

const onSubmit = async () => {
  const isFormValid = await formRef.value.validate();

  if (!isFormValid.valid && props.experienceModalType === "add") return;

  try {
    let payload = {} as any;
    let logo = "";
    let attachments = [] as any;

    if (
      (props.experienceModalType === "add" &&
        selectedAttachments.value.length) ||
      (props.experienceModalType === "edit" && selectedAttachments.value.length)
    ) {
      isUploadImg.value = true;
      // const attachments = [] as any;
      for (const attachment of selectedAttachments.value) {
        const formData = new FormData();
        formData.append("file", attachment);
        const uploadImg = await store.dispatch(
          `${USER_STORE}/uploadProfileImage`,
          formData
        );

        if (uploadImg?.publicUrl) {
          attachments.push(uploadImg);
        } else {
          displayToastMessage(
            internalInstance,
            "Failed to upload an attachment.",
            "error"
          );
        }
      }
      console.log(payload, "payload");
    }

    if (props.experienceModalType === "add") {
      payload = {
        companyName: companyName.value,
        title: title.value,
        isPresent: isPresent.value,
        startDate: moment(startDate.value, "YYYY-MM-DD").format("YYYY-MM-DD"),
        endDate: getEndDate(),
        attachments,
      };

      const request = {
        userId: user.value?.id,
        payload,
      };

      console.log(request, "request");

      const response = await store.dispatch(
        `${USER_STORE}/addTradePassportExperience`,
        request
      );

      console.log(response, "response");

      if (response) {
        emits("on-success");
      }
    }

    if (props.experienceModalType === "edit") {
      let attachment = {} as any;
      if (
        props.selectedExperienceData?.attachments &&
        props.selectedExperienceData?.attachments.length
      ) {
        attachment = {
          ...attachments[0],
          id: props.selectedExperienceData?.attachments[
            props.selectedExperienceData?.attachments.length - 1
          ].id,
        };
      }

      if (selectedAttachments.value.length) {
        payload = {
          experienceId: props.selectedExperienceData?.id,
          companyName: companyName.value,
          title: title.value,
          isPresent: isPresent.value,
          startDate: moment(startDate.value, "YYYY-MM-DD").format("YYYY-MM-DD"),
          endDate: getEndDate(),
          attachment,
        };
      } else {
        attachment = null;
        payload = {
          experienceId: props.selectedExperienceData?.id,
          companyName: companyName.value,
          title: title.value,
          isPresent: isPresent.value,
          startDate: moment(startDate.value, "YYYY-MM-DD").format("YYYY-MM-DD"),
          endDate: getEndDate(),
          attachment,
        };
      }

      const request = {
        userId: user.value?.id,
        id: props.selectedExperienceData?.id,
        payload,
      };

      console.log(request, "request");

      const response = await store.dispatch(
        `${USER_STORE}/updateTradePassportExperienceById`,
        request
      );

      console.log(response, "response");

      if (response) {
        emits("on-success");
      }
    }

    // store.dispatch(`${WORKSTATION}/setActiveUserWorkstation`);

    // console.log(response, "response");

    // emits("on-submit", { userMessageContent, disputeOffer });
  } catch (error: any) {
    if (error.response) {
      if (error.response.status) {
        const errorMessage =
          error.response.data.message || "An error occurred. Please try again.";
        displayToastMessage(internalInstance, errorMessage, "error");
      } else {
        // Handle other status codes or errors
        displayToastMessage(
          internalInstance,
          `Error: ${error.response.statusText}`,
          "error"
        );
      }
    } else {
      displayToastMessage(
        internalInstance,
        "The request took too long and timed out. Please try again later.",
        "error"
      );
    }
  } finally {
    isUploadImg.value = false;
    companyName.value = "";
    title.value = "";
    startDate.value = "";
    endDate.value = null;
    isPresent.value = false;
    selectedAttachments.value = [];
    onClickBackButton();
  }
};

const removeAttachment = (index: number) => {
  selectedAttachments.value.splice(index, 1);
};

const onClickBackButton = () => {
  companyName.value = "";
  title.value = "";
  startDate.value = "";
  endDate.value = null;
  isPresent.value = false;
  selectedAttachments.value = [];
  return emits("on-close");
};

watch(
  () => isPresent.value,
  () => {
    setEndDate();
  },
  { immediate: true, deep: true }
);

onMounted(() => {
  if (props.selectedExperienceData) {
    console.log(props.selectedExperienceData, "selectedExperienceData");
    companyName.value = props.selectedExperienceData?.companyName;
    title.value = props.selectedExperienceData?.title;
    startDate.value = formatIssueDate(props.selectedExperienceData?.startDate);
    endDate.value = formatIssueDate(props.selectedExperienceData?.endDate);
    isPresent.value = props.selectedExperienceData?.isPresent;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "dispute-evidence-modal !tw-gap-0 !tw-z-[2000]",
    onOnClose: onClickBackButton,
    maxWidth: "100%",
    width: "588px",
    borderRadius: "8px",
    isShowCloseButton: true,
    isShowHeader: true,
    isTitleStrong: false,
    headerTitle: 
      props.experienceModalType === 'add' ? 'Add Experience' : 'Edit Experience'
    ,
    headerDescription: "Upload Experience Logo in PDF, JPG, or PNG format.",
    headerDescriptionTextSize: "span",
    headerDescriptionLineHeight: "18px",
    gap: "0"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_form, {
            ref_key: "formRef",
            ref: formRef,
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
            rules: validation.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(Text, {
                      variant: "span",
                      lineHeight: "18px",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Company Name")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(InputField, {
                    class: "!tw-w-full custom-selector",
                    modelValue: companyName.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((companyName).value = $event)),
                    rules: validation.value.companyName,
                    placeholder: "Enter Company Name"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(Text, {
                      variant: "span",
                      lineHeight: "18px",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Title")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(InputField, {
                    class: "!tw-w-full custom-selector",
                    modelValue: title.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((title).value = $event)),
                    rules: validation.value.title,
                    placeholder: "Enter Title"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(Text, {
                      variant: "span",
                      lineHeight: "18px",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Start Date")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_date_picker, {
                    class: "tw-min-h-[2.625rem] tw-max-h-[2.625rem] !tw-w-full",
                    type: "date",
                    placeholder: "Select Start Date",
                    "value-format": "DD-MM-YYYY",
                    format: _unref(DATE_FORMAT),
                    modelValue: startDate.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startDate).value = $event)),
                    rules: validation.value.startDate
                  }, null, 8, ["format", "modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(Text, {
                      variant: "span",
                      lineHeight: "18px",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("End Date")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_date_picker, {
                    class: "tw-min-h-[2.625rem] tw-max-h-[2.625rem] !tw-w-full",
                    type: "date",
                    placeholder: "Select Start Date",
                    "value-format": "DD-MM-YYYY",
                    format: _unref(DATE_FORMAT),
                    modelValue: endDate.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((endDate).value = $event)),
                    disabled: isPresent.value
                  }, null, 8, ["format", "modelValue", "disabled"])
                ]),
                _createVNode(_component_v_checkbox, {
                  modelValue: isPresent.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isPresent).value = $event)),
                  color: "primary",
                  label: "Currently Working Here"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border",
                  onClick: onClickBackButton,
                  disabled: isUploadImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  class: "button button-purple",
                  onClick: onSubmit,
                  loading: isUploadImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.experienceModalType === "add"
                    ? "Submit Experience"
                    : "Update"), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["rules"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["headerTitle"]))
}
}

})